import { Module } from 'vuex'
import actions from './actions'
import RootState from '@vue-storefront/core/types/RootState'
import StockState from '@vue-storefront/core/modules/catalog/types/StockState'

export const stockModule: Module<StockState, RootState> = {
  actions
}
